var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('el-image',{staticClass:"introImg",attrs:{"src":_vm.baseImgUrl + _vm.introImg}}),_c('div',{staticClass:"cont"},[_vm._v(_vm._s(_vm.into))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }